import {RangeType, SpellRange} from '../../generated/types';

/** Области с центром на заклинателе: куб, конус, сфера… — у них дистанция «На себя (…)» */
const AREA_RANGE_TYPES = [
	RangeType.cube,
	RangeType.cone,
	RangeType.line,
	RangeType.sphere,
	RangeType.radius,
	RangeType.hemisphere,
	RangeType.emanation,
];

export function isSpellAreaRange(range: SpellRange): boolean {
	return AREA_RANGE_TYPES.includes(range.type);
}
